import { render, staticRenderFns } from "./historytakinghpi.vue?vue&type=template&id=6615c194&"
import script from "./historytakinghpi.vue?vue&type=script&lang=js&"
export * from "./historytakinghpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports